import { render, staticRenderFns } from "./ImportExportButton.vue?vue&type=template&id=6562649a&scoped=true"
import script from "./ImportExportButton.vue?vue&type=script&lang=js"
export * from "./ImportExportButton.vue?vue&type=script&lang=js"
import style0 from "./ImportExportButton.vue?vue&type=style&index=0&id=6562649a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562649a",
  null
  
)

export default component.exports